import { Grid } from '@mui/material';
import SwitcherButton, {
  SwitcherButtonColorType,
} from './FileTypeSwitcher/SwitcherButton';
import { FolderType } from 'types';
import useStyles from './FileTypeSwitcher.styles';

const FileTypeSwitcher = (): JSX.Element => {
  const classes = useStyles();

  return (
    <Grid className={classes.container} container spacing={4}>
      <Grid item>
        <SwitcherButton
          color={SwitcherButtonColorType.GREEN}
          dataTestId="photo-button"
          fileType={FolderType.PICTURE_AND_VIDEO}
          labelId="share.switcher.photo"
        />
      </Grid>
      <Grid item>
        <SwitcherButton
          color={SwitcherButtonColorType.RED}
          dataTestId="document-button"
          fileType={FolderType.OFFICE}
          labelId="share.switcher.document"
        />
      </Grid>
      <Grid item>
        <SwitcherButton
          color={SwitcherButtonColorType.YELLOW}
          dataTestId="music-button"
          fileType={FolderType.MUSIC}
          labelId="share.switcher.music"
        />
      </Grid>
    </Grid>
  );
};

export default FileTypeSwitcher;
